import styled, { css } from 'styled-components'

import { grayDark } from '../../../utils/style-utils'
import { TournamentWithMembership } from '../../Tournaments/types/Tournament'

type Props = Pick<TournamentWithMembership, 'background'>

export const Wrapper = styled.div.withConfig<Props>({
  shouldForwardProp: (prop) => !prop.includes('backgroundUrl'),
})`
  background-position: center;
  background-size: cover;
  ${({ background }) =>
    background
      ? css`
          background: url(${background.big});
        `
      : css`
          background-color: ${grayDark};
        `}
`
